<template>
    <Layout>

        <PageHeader :title="title" :items="items" />

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <DualListBox
                                :source="source"
                                :destination="destination"
                                label="name"
                                @onChangeList="onChangeList">
                        </DualListBox>
                        <div class="col-md-6">
                            <div class="form-group">
                                <button type="submit" class="btn btn-primary" @click="submit" >Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>

  import appConfig from '@src/app.config'
  import Layout from '@layouts/main'
  import PageHeader from '@components/page-header'
  import DualListBox from "dual-listbox-vue";

  import { companiesMethods } from '@state/helpers'

  export default {
    page: {
      title: 'Assign Products',
      meta: [{ name: 'description', content: appConfig.description }],
    },

    components: { Layout, PageHeader, DualListBox },
    data: function () {
      return {
        title: 'Assign Products',
        items: [
          {
            text: '99Gift',
            href: '/',
          },
          {
            text: 'Companies',
            href: '/',
          },
          {
            text: this.$route.params.company || '',
            href: '/',
          },
          {
            text: 'Assign-Product',
            active: true,
          },
        ],
        id: null,
        company: null,
        source: [],
        destination: []
      };
    },
    mounted(){
      this.id = parseInt(this.$route.params.id)
      this.company = this.$route.params.company

      this.products()

    },
    methods: {

      ...companiesMethods,

      products: async function(){

        try{
          const { success, message, data: { result } } = await this.companyProducts(this.id);

          if(!success) throw Error(message)

          const { assigned, notAssigned } = result;

          this.source = notAssigned
          this.destination = assigned
        }
        catch (e){

          this.source = []
          this.destination = []
          this.appToast('Error', e.message || 'Error while operating', 'danger')
        }
      },

      onChangeList: function ({ source, destination }) {
        this.source = source;
        this.destination = destination;
      },

      submit: async function(){

        const assign = [];

        this.destination.forEach(each=>{
          assign.push(each.sku)
        })

        try{
          const { success, message } = await this.companyAssignProducts({
            company: this.id,
            products:assign
          });

          if(!success) throw Error(message)

          this.appToast('Product assigned successfully','Selected products are assigned successfully', 'success')

          this.products();
        }
        catch (e){

          this.appToast('Error', e.message || 'Error while operating', 'danger')
        }
      }
    }
  }

</script>